<template>
  <div class="content-header">
    <div class="left-logo" @click="toHome">
      <div class="logo2">
        <img src="@/assets/logo_new.png" alt="" />
      </div>
    </div>
    <div class="nav-tab">
      <router-link
        :to="{
          path: item.url,
          query: {
            moduleTitle: item.name,
          },
        }"
        :class="[$route.query.moduleTitle === item.name ? 'activities' : '']"
        v-for="(item, index) in navList"
        :key="item.id"
        style="font-size: 18px"
      >
        <div v-if="index < 7" style="font-size: 18px">{{ item.name }}</div>
      </router-link>
      <div v-if="navList.length > 7" class="more" @click="showMore">
        {{ showMoreModule ? "收起" : "展开" }}
      </div>
      <div class="more-module" v-if="showMoreModule">
        <div
          v-for="(item, index) in navList"
          :key="item.id"
          style="height: 96px"
        >
          <div
            v-if="index >= 7"
            @click="toDetail(item.name)"
            :class="[
              'nav-item2',
              $route.query.moduleTitle === item.name ? 'activities' : '',
            ]"
          >
            <div style="font-size: 18px">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="mask" v-if="showMoreModule"></div>
    </div>
    <div class="right-login">
      <!-- <div class="search">
        <el-input
          v-model.trim="search"
          suffix-icon="el-icon-search"
          placeholder="搜索"
        ></el-input>
      </div> -->
      <div class="btn" v-if="!hadLogin">
        <el-button class="register" @click="toRegister">注册</el-button>
        <el-button class="login" @click="toLogin">登录</el-button>
      </div>
      <div class="btn" v-if="hadLogin">
        <el-dropdown @command="handleCommand">
          <div>
            <user-info :item="userInfo"></user-info>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              command="manage"
              v-if="rolesList.includes('admin') || rolesList.includes('depart')"
              >系统管理</el-dropdown-item
            >
            <el-dropdown-item command="c">修改密码</el-dropdown-item>
            <el-dropdown-item command="b">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import userInfo from "@/views/components/userInfo.vue";
import http from "@/utils/http.js";
import { showMessage } from "@/utils/message";
export default {
  name: "TabHeader",
  components: { userInfo },
  data() {
    return {
      navList: [],
      search: "",
      currentPage: "",
      login: sessionStorage.getItem("X-Access-Token") ? true : false,
      userInfo: {},
      showMoreModule: false,
      rolesList: JSON.parse(sessionStorage.getItem("rolesList")),
    };
  },
  computed: {
    hadLogin() {
      return this.$store.state.isLogin;
    },
  },
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    console.log(`${process.env.NODE_ENV}`);
    if (sessionStorage.getItem("X-Access-Token")) {
      this.$store.commit("changeIsLogin", { login: true });
    }
    this.getMenu();
    //web3/module
  },
  watch: {
    // 这里根据不同页面，两个按钮的显示隐藏
    hadLogin: {
      handler(val) {
        this.login = val;
        this.getMenu();
      },
      immediate: true,
    },
  },
  methods: {
    toHome() {
      if (
        this.$route.path !== "/?moduleTitle=首页" ||
        this.$route.path !== "/"
      ) {
        this.$router.push("/?moduleTitle=首页");
      }
    },
    toDetail(val) {
      this.showMoreModule = false;
      this.$router.push(`/web3/module?moduleTitle=${val}`);
    },
    showMore() {
      this.showMoreModule = !this.showMoreModule;
    },
    getMenu() {
      http.get("/module/menuList").then((res) => {
        if (res.success) {
          const result = res.result;
          if (result.records) {
            let navArr = result.records.map((item) => {
              item = {
                ...item,
                name: item.moduleTitle,
                url: item.moduleTitle === "首页" ? "/" : "/web3/module",
              };
              return item;
            });
            navArr.unshift({
              name: "首页",
              url: "/",
            });
            this.navList = navArr;
          }
        } else {
          showMessage(res.message, "info");
        }
      });
    },
    currentStyle() {},
    handleCommand(command) {
      event.preventDefault();
      if (command === "c") {
        this.$router.push("/editPassword");
        return;
      }
      if (command === "a") {
        this.$router.push("/userCenter");
      } else if (command === "manage") {
        this.$router.push("/manage/store");
      } else {
        this.$router.push("/?moduleTitle=首页");
        sessionStorage.removeItem("X-Access-Token");
        sessionStorage.removeItem("rolesList");
        sessionStorage.removeItem("userInfo");
        this.$store.commit("changeIsLogin", {
          login: false,
        });
        this.getMenu();
      }
    },
    toLogin() {
      this.$router.push("/login");
    },
    toRegister() {
      this.$router.push("/register");
    },
  },
};
</script>

<style lang="less" scoped>
.content-header {
  padding: 0 1.6vw;
  position: relative;
  z-index: 10;
  height: 96px;
  width: 96.8vw;
  display: flex;
  line-height: 96px;
  flex-wrap: nowrap;
  font-size: 24px;
  background: #ffffff;
  outline: 1px solid rgb(203, 203, 203);
  a {
    color: inherit;
    text-decoration: none;
    padding: 0 1.5vw;
  }
  .left-logo {
    img {
      // height: 64px;
      width: 462px;
      margin-top: 4px;
    }
  }
  .nav-tab {
    margin-left: 28px;
    flex: 1;
    position: relative;
    display: flex;
    .more {
      position: absolute;
      right: 120px;
      font-size: 14px;
      color: #008af4;
      cursor: pointer;
    }
    .more-module {
      width: 100%;
      position: absolute;
      z-index: 2;
      display: flex;
      top: 96px;
      background-color: #ffffff;
      border-top: 1px solid rgb(203, 203, 203);
      border-radius: 0 0 8px 8px;
      .nav-item2 {
        height: 96px;
        margin-right: 30px;
        cursor: pointer;
        &:nth-child(1) {
          margin-left: 26px;
        }
      }
    }
  }
  .right-login {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    .search {
      width: 14.5vw;
      visibility: hidden;
      margin-right: 1.6vw;
      /deep/ .el-input--suffix .el-input__inner {
        border-radius: 25px;
        font-size: 20px;
        border: 1px solid #008af4;
      }
      /deep/ .el-input__icon {
        position: absolute;
        font-size: 20px;
        right: 3px;
        bottom: 4px;
        color: #008af4;
      }
    }
    .login,
    .register {
      font-size: 16px;
    }
    .login {
      background: #2fa8e0;
      border-radius: 4px;
      color: #ffffff;
    }
    .register {
      border: 1px solid rgba(47, 168, 224, 1);
      border-radius: 5px;
      background-color: #ffffff;
      color: #008af4;
      margin-left: 1.5vw;
    }
  }
  .mask {
    width: 100vw;
    height: calc(100vh - 96px);
    background-color: rgb(0, 0, 0);
    opacity: 0.3;
    position: absolute;
    top: 96px;
    left: -21.6vw;
    z-index: 1;
  }
  .router-link-exact-active {
    color: #000000;
    font-size: 18px;
  }
  a.activities {
    color: #ffffff;
    font-size: 18px;
  }
  .activities {
    color: #ffffff;
    background: #96d7fb;
    font-size: 18px;
  }
  .el-button:active {
    border: none;
  }
}
</style>
<style lang="less" scoped>
/deep/.userInfo {
  img {
    border-radius: 50% !important;
    margin-top: 28px;
  }
}
/deep/.userInfo .info {
  display: flex;
  height: 20px;
  margin-top: 0px;
  .country {
    margin-top: 12px;
    margin-left: 10px;
  }
}
</style>
